// extracted by mini-css-extract-plugin
export default {"hashControls":"PanelHash_hashControls__XwZl3","hashInput":"PanelHash_hashInput__PkWX1"};